import { render, staticRenderFns } from "./discounts-shipping.vue?vue&type=template&id=7bf2160a&"
import script from "./discounts-shipping.vue?vue&type=script&lang=js&"
export * from "./discounts-shipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports